import { loadStripe } from '@stripe/stripe-js'

export const stripePromise = loadStripe('pk_live_5Fd0YPYnzesR1ve2vMsKkYcp')

// Price IDs from your Stripe dashboard
export const STRIPE_PRICES = {
  TEST: 'price_1R1mLiGA7NgIiRew4uIDdKBK', // Replace with your 1-month price ID
  MONTHLY: 'price_1R1mI0GA7NgIiRewLZRoybFn', // Replace with your 1-month price ID
  // QUARTERLY: 'price_1R1mIOGA7NgIiRew9LDxlTPn', // Replace with your 3-month price ID
}
